import { Resource } from 'store/api/cms/types/response.types';

export const getApiResourceUrl = (resource: Resource) => resource.url;
